import { useEffect, useState } from 'react';
import API from '../../api';
import { useToast } from '../../context/ToastContext';
import { useConfirm } from '../../context/ConfirmContext';
import SearchSelect from '../../components/SearchSelect';

export default function EnseignantSeances() {
  const [seances, setSeances] = useState([]);
  const [cours, setCours] = useState([]);
  const [form, setForm] = useState({ titre: '', cours: '', date: '', contenu: '' });
  const [editId, setEditId] = useState(null);
  const [selectedCours, setSelectedCours] = useState('');
  const { addToast } = useToast();
  const confirm = useConfirm();

  const load = () => {
    const params = selectedCours ? `?cours=${selectedCours}` : '';
    API.get(`seances/${params}`).then((r) => setSeances(r.data.results || r.data));
    API.get('cours/').then((r) => setCours(r.data.results || r.data));
  };
  useEffect(() => { load(); }, [selectedCours]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) { await API.put(`seances/${editId}/`, form); addToast('Séance modifiée', 'success'); }
      else { await API.post('seances/', form); addToast('Séance ajoutée', 'success'); }
      setForm({ titre: '', cours: '', date: '', contenu: '' });
      setEditId(null);
      load();
    } catch { addToast('Erreur lors de l\'opération', 'error'); }
  };

  const handleEdit = (s) => {
    setEditId(s.id);
    setForm({
      titre: s.titre,
      cours: s.cours,
      date: s.date ? s.date.slice(0, 16) : '',
      contenu: s.contenu || '',
    });
  };

  const handleDelete = async (id) => {
    if (await confirm('Supprimer cette séance ?')) { await API.delete(`seances/${id}/`); addToast('Séance supprimée', 'info'); load(); }
  };

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-calendar-event" /> Séances de cours</h2>
      </div>

      <div className="form-glass">
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Titre de la séance</label>
              <input className="form-control" name="titre" placeholder="Titre" value={form.titre} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Cours</label>
              <SearchSelect
                name="cours"
                value={form.cours}
                onChange={handleChange}
                options={cours.map((c) => ({ value: c.id, label: c.titre }))}
                placeholder="-- Sélectionner --"
                required
              />
            </div>
            <div className="form-group">
              <label>Date et heure</label>
              <input className="form-control" name="date" type="datetime-local" value={form.date} onChange={handleChange} required />
            </div>
            <div className="form-group full-width">
              <label>Contenu / description</label>
              <textarea className="form-control" name="contenu" placeholder="Description de la séance" value={form.contenu} onChange={handleChange} />
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary">
              <i className={editId ? 'bi bi-check-lg' : 'bi bi-plus-lg'} /> {editId ? 'Modifier' : 'Ajouter'}
            </button>
            {editId && (
              <button type="button" className="btn btn-secondary" onClick={() => { setEditId(null); setForm({ titre: '', cours: '', date: '', contenu: '' }); }}>
                <i className="bi bi-x-lg" /> Annuler
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="filter-bar">
        <SearchSelect
          className="select-filter-wrap"
          value={selectedCours}
          onChange={(e) => setSelectedCours(e.target.value)}
          options={cours.map((c) => ({ value: c.id, label: c.titre }))}
          placeholder="Tous les cours"
        />
      </div>

      {seances.length === 0 ? (
        <div className="empty-state"><i className="bi bi-calendar-event" /><p>Aucune séance planifiée</p></div>
      ) : (
        <div className="data-table-wrapper">
          <table className="data-table">
            <thead><tr><th>Titre</th><th>Cours</th><th>Date</th><th>Actions</th></tr></thead>
            <tbody>
              {seances.map((s) => {
                const coursObj = cours.find((c) => c.id === s.cours);
                return (
                  <tr key={s.id}>
                    <td>{s.titre}</td>
                    <td>{coursObj?.titre || '–'}</td>
                    <td>{s.date ? new Date(s.date).toLocaleString('fr-FR') : '–'}</td>
                    <td>
                      <button className="btn btn-sm btn-secondary" onClick={() => handleEdit(s)}><i className="bi bi-pencil" /></button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(s.id)}><i className="bi bi-trash" /></button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
